import { render, staticRenderFns } from "./MoreOptions.vue?vue&type=template&id=5aa462f8&scoped=true&"
import script from "./MoreOptions.vue?vue&type=script&lang=js&"
export * from "./MoreOptions.vue?vue&type=script&lang=js&"
import style0 from "./MoreOptions.vue?vue&type=style&index=0&id=5aa462f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa462f8",
  null
  
)

export default component.exports